import { render, staticRenderFns } from "./changeAccount-detail.vue?vue&type=template&id=6722d6bc&scoped=true"
import script from "./changeAccount-detail.vue?vue&type=script&lang=js"
export * from "./changeAccount-detail.vue?vue&type=script&lang=js"
import style0 from "./changeAccount-detail.vue?vue&type=style&index=0&id=6722d6bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6722d6bc",
  null
  
)

export default component.exports